import styled from 'styled-components';
import { MEDIUM_GRAY, WHITE, BLUE, ORANGE, LIGHT_GRAY, LABEL } from 'root/theme';

const CardHeaderContainer = styled.div`
  color: ${MEDIUM_GRAY};
  font-size: 1.125rem;
  text-align: center;
  display: flex;
  width: 100%;
  justify-content: space-between;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
  border-radius: 30px 30px 0 0;
  overflow: hidden;
  
  @media(max-width: 675px) {
    flex-wrap: wrap;
  }
`;

const QuizName = styled.h4`
  padding: 0.5rem 1rem;
  background-color: ${BLUE};
  color: ${WHITE};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 300px;
  padding-left: 10px;
  border-right: 1px solid ${LIGHT_GRAY};
  @media(max-width: 675px) {
    width: 100%;
    border: none;
  }
`;

const ProgressHeader = styled.div`
  background-color: ${WHITE};
  ${LABEL}
  padding: .5rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-width: 25%;
  border-right: 1px solid ${LIGHT_GRAY};
  flex-grow: 1;
  
  @media(max-width: 675px) {
    width: 50%;
    text-align: left;
    padding-left: none;
    border: none;
    
  }
`;

const SectionText = styled.h4`
  color: ${ORANGE};
  margin-bottom: 0rem;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;
`;

const PercentCorrect = styled.div`
  padding: .5rem 1rem;
  min-width: 25%;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  ${LABEL}
  
  @media(max-width: 675px) {
    width: 50%;
    text-align: left;
    padding: none;
  }
`;

export {
  CardHeaderContainer,
  QuizName,
  ProgressHeader,
  SectionText,
  PercentCorrect,
};
